import { createFocusTrap, FocusTrap } from 'focus-trap';
import { on } from 'delegated-events';
import type { Instance } from '@popperjs/core';
import invisibleFocus from '../../../javascripts/utils/invisibleFocus';

let focusTrap: FocusTrap;
let popper: Instance;

on('click', 'button.copyright__button', async (event) => {
  const { currentTarget: $button } = event;
  const $parent = $button.closest<HTMLDivElement>('.copyright');
  const $tooltip = $parent?.querySelector<HTMLDivElement>(
    '.copyright__tooltip',
  );

  if ($parent && $tooltip) {
    event.preventDefault();

    const { default: createPopper } = await import(
      /* webpackChunkName: "create-popper" */ '../../../javascripts/utils/createPopper'
    );

    if (!$tooltip.hidden) {
      focusTrap?.deactivate();
    } else {
      $tooltip.hidden = false;

      popper = createPopper($button, $tooltip, {
        placement: 'top-end',
        strategy: 'fixed',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1],
            },
          },
        ],
      });

      focusTrap = createFocusTrap($parent, {
        onDeactivate() {
          $tooltip.hidden = true;
          popper?.destroy();
          invisibleFocus($button);
        },
        initialFocus: '.copyright__tooltip',
        clickOutsideDeactivates: true,
        returnFocusOnDeactivate: false,
        preventScroll: false,
      });

      focusTrap.activate();
    }
  }
});
